import { FaHeart } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import "./LikeHeart.css";

const PARTICLE_COUNT = 8;

/**
 * Twitter-style like heart with pop + particle burst when liking.
 * Pass `animating` only when transitioning to liked (not on unlike).
 */
export default function LikeHeart({
  liked = false,
  animating = false,
  size = 14,
  likedColor = "#f26522",
  unlikedColor = "#6b7280",
  className = "",
}) {
  const showBurst = Boolean(animating && liked);

  return (
    <span
      className={`like-heart${showBurst ? " like-heart--burst" : ""}${
        className ? ` ${className}` : ""
      }`}
      style={{ width: size, height: size, fontSize: size }}
      aria-hidden="true"
    >
      {showBurst && (
        <>
          <span className="like-heart__ring" />
          <span className="like-heart__ring--outer" />
          {Array.from({ length: PARTICLE_COUNT }, (_, i) => (
            <span
              key={i}
              className={`like-heart__particle like-heart__particle--${i}${
                i % 2 === 1 ? " like-heart__particle--spark" : ""
              }`}
            />
          ))}
        </>
      )}
      {liked ? (
        <FaHeart className="like-heart__icon" color={likedColor} size={size} />
      ) : (
        <FiHeart className="like-heart__icon" color={unlikedColor} size={size} />
      )}
    </span>
  );
}

export const LIKE_BURST_MS = 900;
